import { Injectable } from '@angular/core';
import {
  TechnicalServiceCategoryKey,
  TechnicalServiceCategoryOrder,
  TechnicalServiceHeaderOrder,
  TECHNICAL_SERVICE_CATEGORY_ORDER,
  normalizeTechnicalServiceCategoryOrder,
  createEmptyTechnicalServiceHeaderOrder,
  getCategoryForServiceType
} from '../../utils/technical-service-categories';
import {
  TechnicalServiceCatalogItem,
  TechnicalServiceSelectOptionGroup
} from './technical-services-ordering.types';

type ServiceDefinition = {
  serviceType: string;
  headerKey: string;
  translationKey: string;
};

const SERVICE_DEFINITIONS: ServiceDefinition[] = [
  { serviceType: 'Waste Disposal', headerKey: 'WASTE_DISPOSAL', translationKey: 'WASTE_DISPOSAL' }, // Abfallentsorgung
  { serviceType: 'Meter Reading Service', headerKey: 'METER_READING_SERVICE', translationKey: 'METER_READING_SERVICE' }, // Ablesedienst
  { serviceType: 'Elevator', headerKey: 'ELEVATOR', translationKey: 'ELEVATOR' }, // Aufzug
  { serviceType: 'Property Developer', headerKey: 'PROPERTY_DEVELOPER', translationKey: 'PROPERTY_DEVELOPER' }, // Bauträger
  { serviceType: 'Coating (UG)', headerKey: 'COATING_UG', translationKey: 'COATING_UG' }, // Beschichtung (TG)
  { serviceType: 'Fire Alarm System', headerKey: 'FIRE_ALARM_SYSTEM', translationKey: 'FIRE_ALARM_SYSTEM' }, // Brandmeldeanlage
  { serviceType: 'Fire Doors', headerKey: 'FIRE_DOORS', translationKey: 'FIRE_DOORS' }, // Brandschutztüren
  { serviceType: 'Double Parker', headerKey: 'DOUBLE_PARKER', translationKey: 'DOUBLE_PARKER' }, // Doppelparker
  { serviceType: 'Energy Supply', headerKey: 'ENERGY_SUPPLY', translationKey: 'ENERGY_SUPPLY' }, // Energieversorgung
  { serviceType: 'Electrical', headerKey: 'ELECTRICAL', translationKey: 'ELECTRICAL' }, // Elektrik
  { serviceType: 'District Heating Supplier', headerKey: 'DISTRICT_HEATING_SUPPLIER', translationKey: 'DISTRICT_HEATING_SUPPLIER' }, // Fernwärmelieferant
  { serviceType: 'Windows', headerKey: 'WINDOWS', translationKey: 'WINDOWS' }, // Fenster
  { serviceType: 'Fire Extinguisher', headerKey: 'FIRE_EXTINGUISHER', translationKey: 'FIRE_EXTINGUISHER' }, // Feuerlöscher
  { serviceType: 'Garage Door', headerKey: 'GARAGE_DOOR', translationKey: 'GARAGE_DOOR' }, // Garagentor
  { serviceType: 'Garden Maintenance', headerKey: 'GARDEN_MAINTENANCE', translationKey: 'GARDEN_MAINTENANCE' }, // Gartenpflege
  { serviceType: 'Gas Emergency/Gas Odor', headerKey: 'GAS_EMERGENCY_GAS_ODOR', translationKey: 'GAS_EMERGENCY_GAS_ODOR' }, // Gas-Störung, Gasgeruch
  { serviceType: 'Gas Supply/Emergency Service', headerKey: 'GAS_SUPPLY_EMERGENCY_SERVICE', translationKey: 'GAS_SUPPLY_EMERGENCY_SERVICE' }, // Gasversorgung/Störungsdienst
  { serviceType: 'Building Insurance', headerKey: 'BUILDING_INSURANCE', translationKey: 'BUILDING_INSURANCE' }, // Gebäudeversicherung
  { serviceType: 'Fiber / Internet', headerKey: 'FIBER_INTERNET', translationKey: 'FIBER_INTERNET' }, // Glasfaser / Internet
  { serviceType: 'Green Roof Maintenance', headerKey: 'GREEN_ROOF_MAINTENANCE', translationKey: 'GREEN_ROOF_MAINTENANCE' }, // Gründachpflege
  { serviceType: 'Green Pruning', headerKey: 'GREEN_PRUNING', translationKey: 'GREEN_PRUNING' }, // Grünschnitt
  { serviceType: 'Lifting Systems and Pumps', headerKey: 'LIFTING_SYSTEMS_AND_PUMPS', translationKey: 'LIFTING_SYSTEMS_AND_PUMPS' }, // Hebeanlagen und Pumpen
  { serviceType: 'Heating', headerKey: 'HEATING', translationKey: 'HEATING' }, // Heizung
  { serviceType: 'Heating Cost Allocator', headerKey: 'HEATING_COST_ALLOCATOR', translationKey: 'HEATING_COST_ALLOCATOR' }, // Heizkostenabrechner
  { serviceType: 'Heating Oil Supply', headerKey: 'HEATING_OIL_SUPPLY', translationKey: 'HEATING_OIL_SUPPLY' }, // Heizölversorgung
  { serviceType: 'Cable Television', headerKey: 'CABLE_TELEVISION', translationKey: 'CABLE_TELEVISION' }, // Kabelfernsehen
  { serviceType: 'Sewer/Blockage', headerKey: 'SEWER_BLOCKAGE', translationKey: 'SEWER_BLOCKAGE' }, // Kanal-/verstopfung
  { serviceType: 'Ventilation', headerKey: 'VENTILATION', translationKey: 'VENTILATION' }, // Lüftung
  { serviceType: 'Rental Mat Service', headerKey: 'RENTAL_MAT_SERVICE', translationKey: 'RENTAL_MAT_SERVICE' }, // Mietmattenservice
  { serviceType: 'Local Heating Supplier', headerKey: 'LOCAL_HEATING_SUPPLIER', translationKey: 'LOCAL_HEATING_SUPPLIER' }, // Nahwärmeversorger
  { serviceType: 'Electric Storage Heater', headerKey: 'ELECTRIC_STORAGE_HEATER', translationKey: 'ELECTRIC_STORAGE_HEATER' }, // Nachtspeicherofen
  { serviceType: 'Police', headerKey: 'POLICE', translationKey: 'POLICE' }, // Polizei
  { serviceType: 'Smoke and Heat Extraction System', headerKey: 'SMOKE_AND_HEAT_EXTRACTION_SYSTEM', translationKey: 'SMOKE_AND_HEAT_EXTRACTION_SYSTEM' }, // Rauch- und Wärmeabzugsanlage
  { serviceType: 'Smoke Detector', headerKey: 'SMOKE_DETECTOR', translationKey: 'SMOKE_DETECTOR' }, // Rauchmelder
  { serviceType: 'Roller Shutter/Raffstore', headerKey: 'ROLLER_SHUTTER_RAFFSTORE', translationKey: 'ROLLER_SHUTTER_RAFFSTORE' }, // Rollo/Raffstore
  { serviceType: 'Pipe Blockage', headerKey: 'PIPE_BLOCKAGE', translationKey: 'PIPE_BLOCKAGE' }, // Rohrverstopfung
  { serviceType: 'Pipe Burst & Water Damage', headerKey: 'PIPE_BURST_WATER_DAMAGE', translationKey: 'PIPE_BURST_WATER_DAMAGE' }, // Rohrbruch & Wasserschaden
  { serviceType: 'Sanitary', headerKey: 'SANITARY', translationKey: 'SANITARY' }, // Sanitär
  { serviceType: 'Pest Control', headerKey: 'PEST_CONTROL', translationKey: 'PEST_CONTROL' }, // Schädlingsbekämpfung
  { serviceType: 'Locking System Maintenance', headerKey: 'LOCKING_SYSTEM_MAINTENANCE', translationKey: 'LOCKING_SYSTEM_MAINTENANCE' }, // Schließanlage
  { serviceType: 'Locksmith Service', headerKey: 'LOCKSMITH_SERVICE', translationKey: 'LOCKSMITH_SERVICE' }, // Schlüsseldienst
  { serviceType: 'Chimney Sweep', headerKey: 'CHIMNEY_SWEEP', translationKey: 'CHIMNEY_SWEEP' }, // Schornsteinfeger
  { serviceType: 'Solar System/PVA', headerKey: 'SOLAR_SYSTEM_PVA', translationKey: 'SOLAR_SYSTEM_PVA' }, // Solaranlage/PVA
  { serviceType: 'Bulk Waste Collection', headerKey: 'BULK_WASTE_COLLECTION', translationKey: 'BULK_WASTE_COLLECTION' }, // Sperrmüllabholung
  { serviceType: 'Street and Sidewalk Cleaning', headerKey: 'STREET_AND_SIDEWALK_CLEANING', translationKey: 'STREET_AND_SIDEWALK_CLEANING' }, // Straßen- und Gehwegreinigung
  { serviceType: 'Power Supply/Emergency Service', headerKey: 'POWER_SUPPLY_EMERGENCY_SERVICE', translationKey: 'POWER_SUPPLY_EMERGENCY_SERVICE' }, // Stromversorger/Störungsdienst
  { serviceType: 'Gate/Gate Systems', headerKey: 'GATE_GATE_SYSTEMS', translationKey: 'GATE_GATE_SYSTEMS' }, // Tore/Toranlagen
  { serviceType: 'Stairwell Cleaning', headerKey: 'STAIRWELL_CLEANING', translationKey: 'STAIRWELL_CLEANING' }, // Treppenhausreinigung
  { serviceType: 'Doors', headerKey: 'DOORS', translationKey: 'DOORS' }, // Türen
  { serviceType: 'Roofer', headerKey: 'ROOFER', translationKey: 'ROOFER' }, // Dachdecker
  { serviceType: 'Water Supply', headerKey: 'WATER_SUPPLY', translationKey: 'WATER_SUPPLY' }, // Wasserversorgung
  { serviceType: 'WE Meter', headerKey: 'WE_METER', translationKey: 'WE_METER' }, // WE-Zähler
  { serviceType: 'Recyclable Waste Disposal', headerKey: 'RECYCLABLE_WASTE_DISPOSAL', translationKey: 'RECYCLABLE_WASTE_DISPOSAL' }, // Wertstoffentsorgung
  { serviceType: 'Winter Service', headerKey: 'WINTER_SERVICE', translationKey: 'WINTER_SERVICE' }, // Winterdienst
  { serviceType: 'Apartment Transfer Station (DHW/Heating)', headerKey: 'APARTMENT_TRANSFER_STATION_DHW_HEATING', translationKey: 'APARTMENT_TRANSFER_STATION_DHW_HEATING' } // Wohnungsübergabestation (WW/ Hzg)
];

@Injectable({
  providedIn: 'root'
})
export class TechnicalServicesOrderingService {
  readonly serviceCatalog: TechnicalServiceCatalogItem[] = SERVICE_DEFINITIONS.map((service) => ({
    ...service,
    categoryKey: getCategoryForServiceType(service.serviceType)
  }));

  private readonly serviceByHeaderKey = new Map(
    this.serviceCatalog.map((service) => [service.headerKey, service])
  );

  readonly selectGroups: TechnicalServiceSelectOptionGroup[] = TECHNICAL_SERVICE_CATEGORY_ORDER.map((categoryKey) => ({
    categoryKey,
    categoryTranslationKey: `COMPANY_PAGE.TECHNICAL_SERVICE_CATEGORIES.${categoryKey}`,
    options: this.serviceCatalog.filter((service) => service.categoryKey === categoryKey)
  }));

  getServiceByHeaderKey(headerKey: string): TechnicalServiceCatalogItem | undefined {
    return this.serviceByHeaderKey.get((headerKey || '').trim().toUpperCase());
  }

  normalizeSelectedHeaderKeys(headerKeys: string[] | null | undefined): string[] {
    const seen = new Set<string>();
    const normalized: string[] = [];

    (Array.isArray(headerKeys) ? headerKeys : []).forEach((rawKey) => {
      const key = (rawKey || '').trim().toUpperCase();
      if (!key || seen.has(key) || !this.serviceByHeaderKey.has(key)) {
        return;
      }
      seen.add(key);
      normalized.push(key);
    });

    return normalized;
  }

  normalizeHeaderOrder(
    order: Partial<TechnicalServiceHeaderOrder> | null | undefined,
    selectedHeaderKeys: string[] | null | undefined
  ): TechnicalServiceHeaderOrder {
    const normalizedSelection = this.normalizeSelectedHeaderKeys(selectedHeaderKeys);
    const selectionSet = new Set(normalizedSelection);
    const normalizedOrder = createEmptyTechnicalServiceHeaderOrder();
    const seen = new Set<string>();

    TECHNICAL_SERVICE_CATEGORY_ORDER.forEach((categoryKey) => {
      const values = Array.isArray(order?.[categoryKey]) ? order![categoryKey]! : [];
      values.forEach((value) => {
        const headerKey = (value || '').trim().toUpperCase();
        if (!headerKey || seen.has(headerKey) || !selectionSet.has(headerKey)) {
          return;
        }
        seen.add(headerKey);
        normalizedOrder[categoryKey].push(headerKey);
      });
    });

    normalizedSelection.forEach((headerKey) => {
      if (seen.has(headerKey)) {
        return;
      }
      const service = this.serviceByHeaderKey.get(headerKey);
      const categoryKey = service?.categoryKey || 'TECHNICAL_SERVICE';
      normalizedOrder[categoryKey].push(headerKey);
      seen.add(headerKey);
    });

    return normalizedOrder;
  }

  applySelectionToOrder(
    selectedHeaderKeys: string[] | null | undefined,
    currentOrder: Partial<TechnicalServiceHeaderOrder> | null | undefined
  ): TechnicalServiceHeaderOrder {
    return this.normalizeHeaderOrder(currentOrder, selectedHeaderKeys);
  }

  getOrderedSelectedHeaderKeys(order: TechnicalServiceHeaderOrder): string[] {
    return this.getOrderedSelectedHeaderKeysByCategoryOrder(order, TECHNICAL_SERVICE_CATEGORY_ORDER);
  }

  getOrderedSelectedHeaderKeysByCategoryOrder(
    order: TechnicalServiceHeaderOrder,
    categoryOrder: TechnicalServiceCategoryOrder | null | undefined
  ): string[] {
    return normalizeTechnicalServiceCategoryOrder(categoryOrder).flatMap((categoryKey) => order[categoryKey] || []);
  }

  normalizeCategoryOrder(categoryOrder: TechnicalServiceCategoryOrder | null | undefined): TechnicalServiceCategoryOrder {
    return normalizeTechnicalServiceCategoryOrder(categoryOrder);
  }

  createOrderPayload(
    order: TechnicalServiceHeaderOrder,
    categoryOrder: TechnicalServiceCategoryOrder | null | undefined
  ): {
    technicalServiceHeaderOrder: TechnicalServiceHeaderOrder;
    technicalServiceCategoryOrder: TechnicalServiceCategoryOrder;
  } {
    const normalizedCategoryOrder = this.normalizeCategoryOrder(categoryOrder);
    return {
      technicalServiceHeaderOrder: this.normalizeHeaderOrder(
        order,
        this.getOrderedSelectedHeaderKeysByCategoryOrder(order, normalizedCategoryOrder)
      ),
      technicalServiceCategoryOrder: normalizedCategoryOrder
    };
  }

  getCategoryDropListId(categoryKey: TechnicalServiceCategoryKey): string {
    return `technical-service-header-order-${categoryKey.toLowerCase()}`;
  }
}
